import React from "react";
import "../App.css";

export default function WhyUs() {
  return (
    <section id="whyus" className="why-section">
      <div className="container">
        <h2 className="section-title">Why Choose Us?</h2>

        <div className="why-grid">

          <div className="why-card img-card" style={{ backgroundImage: `url("/card-bg.jpg")` }}>
            <div className="overlay"></div>
            <h3>Strong Builder Network</h3>
            <p>
              Direct associations with leading builders,
              guaranteed authenticity and exclusive offers.
            </p>
          </div>

          <div className="why-card img-card" style={{ backgroundImage: `url("/card-bg.jpg")` }}>
            <div className="overlay"></div>
            <h3>Market Knowledge</h3>
            <p>
              Deep insight into market trends, pricing, and ROI potential.
            </p>
          </div>

          <div className="why-card img-card" style={{ backgroundImage: `url("/card-bg.jpg")` }}>
            <div className="overlay"></div>
            <h3>Personalized Guidance</h3>
            <p>
              Every client's requirement is unique — we help you make the right decision.
            </p>
          </div>

          <div className="why-card img-card" style={{ backgroundImage: `url("/card-bg.jpg")` }}>
            <div className="overlay"></div>
            <h3>Zero Brokerage</h3>
            <p>
              Buyers receive full support without any extra fees.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}
